import type { TAccessControlRules } from '@frontend/components/agromarket/core/access-control'
import { hasUserPermissions, UserPermission } from '@frontend/components/agromarket/core/access-control'
import type { TLandingAccessControlContext } from './types'
import { ELandingAccessControlValue } from './types'

export const LANDING_ACCESS_CONTROL_LIST = {
  landings: {
    components: {
      header: {
        button: ({ auth }) => {
          const isUserAgrarian = hasUserPermissions([UserPermission.AGRARIAN], auth.user)

          if (!auth.isAuthenticated || isUserAgrarian) {
            return ELandingAccessControlValue.VISIBLE
          }

          return ELandingAccessControlValue.VISIBLE_AND_BLOCKED
        },
      },
      forAgrariansOnlyTooltip: ({ auth }) =>
        hasUserPermissions([UserPermission.AGRARIAN], auth.user) ? ELandingAccessControlValue.HIDDEN : ELandingAccessControlValue.VISIBLE,
      preApprovedLoanBanner: ({ auth, isLoanApproved }) => {
        return isLoanApproved === true && hasUserPermissions([UserPermission.AGRARIAN], auth.user)
          ? ELandingAccessControlValue.VISIBLE
          : ELandingAccessControlValue.HIDDEN
      },
      productHelper: ({ auth, isLoanApproved }) => {
        return isLoanApproved === false && hasUserPermissions([UserPermission.AGRARIAN], auth.user)
          ? ELandingAccessControlValue.VISIBLE
          : ELandingAccessControlValue.HIDDEN
      },
    },
  },
} satisfies Readonly<TAccessControlRules<TLandingAccessControlContext, ELandingAccessControlValue>>
